// Keep alphabetically sorted
// This tool is helpful https://wordcounter.net/alphabetize
export default {
  alabaster: '#F7F7F7',
  alto: '#D1D1D1',
  apricot: '#EC9060',
  apricotPeach: '#F8C7AF',
  blueBayoux: '#476473',
  bombay: '#B0B3B7',
  catskillWhite: '#F3F6F9',
  cornflowerBlue: '#91B9CD',
  doveGray: '#6F6F6F',
  dustyGray: '#9B9B9B',
  emperor: '#4F4F4F',
  gulfstream: '#81BBA8',
  pixieGreen: '#C5DABF',
  porcelain: '#EBEDEF',
  puce: '#CD9199',
  roman: '#DF6262',
  snowGray: '#FAFAFA',
  tonysPink: '#E7A685',
  tundora: '#404040',
  white: '#FFFFFF',
};
